import { Container } from '@/app/components/layouts/container';
import {
  FOOTER_DATA_GA,
  FOOTER_DATA_TEST,
} from '@/app/components/layouts/footer/tracking';
import { Image } from '@/app/components/media/image';
import { Link } from '@/app/components/navigation/link';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';

export interface FooterContactProps {
  title: string;
  contact: {
    href: string;
    image: string;
    alt: string;
    value: string;
  }[];
}
export const FooterContact = ({ title, contact }: FooterContactProps) => {
  return (
    <div
      {...createDataAttributes({
        test: FOOTER_DATA_TEST.contact,
      })}
      className="bg-gray-50 py-6 xl:py-8"
    >
      <Container className="items-center justify-between md:flex">
        {!!title && (
          <h3 className="font-noto-bold text-sub-h3 sr-only md:not-sr-only">
            {title}
          </h3>
        )}
        <div className="flex items-start justify-center gap-x-4 lg:gap-x-6">
          {contact.map((item, i) => (
            <Link
              key={i}
              className="max-w-39 flex-auto md:w-50 md:max-w-none"
              target="_blank"
              href={item.href}
              {...createDataAttributes({
                test: `${FOOTER_DATA_TEST.contactLink}${i}`,
              })}
              {...createDataGA({
                click: true,
                eventName: FOOTER_DATA_GA.event,
                url: item.href,
                text: item.alt,
                value: item.value,
              })}
            >
              <Image
                src={item.image}
                alt={item.alt}
                aspectRatio="aspect-8-3"
                width={207}
                height={62}
                objectFit="contain"
              />
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
};
